import React from 'react';
import { ListItem } from '@mui/material';
import { cx } from '@emotion/css';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Icon, InfoIcon, Tooltip } from '../../../../../atoms';
import useStyles, { isAlwaysEnabledClassName, hasErrorClassName, isDisabledClassName, } from './ColumnSelectorCardItem.styles';
function ColumnSelectorCardItem(props) {
    const { column, onItemSelect, onItemDeselect } = props;
    const classes = useStyles();
    const handleSelect = () => {
        if (!column.alwaysEnabled) {
            onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect(column);
        }
    };
    const handleDeselect = () => {
        if (!column.alwaysEnabled) {
            onItemDeselect === null || onItemDeselect === void 0 ? void 0 : onItemDeselect(column);
        }
    };
    const renderLeftActions = () => {
        if (column.alwaysEnabled || column.disabled) {
            return null;
        }
        else if (props.selected && props.canDrag) {
            return (React.createElement(Icon, { id: "drag-icon", className: classes.dragIcon }, "drag_indicator"));
        }
    };
    const renderEdit = () => {
        if (!column.value.startsWith('custom')) {
            return null;
        }
        return (React.createElement("button", { className: classes.hideUntilHover, onClick: () => { var _a; return (_a = props.onItemEdit) === null || _a === void 0 ? void 0 : _a.call(props, column); } },
            React.createElement(EditOutlinedIcon, { id: "edit-icon", className: classes.editIcon })));
    };
    const renderRemove = () => {
        if (!props.selected || column.alwaysEnabled) {
            return null;
        }
        return (React.createElement("button", { onClick: handleDeselect, "data-testid": column.value + '_remove', className: "button-remove" },
            React.createElement(Icon, { id: "remove-icon", className: classes.icon }, "remove_circle_outline")));
    };
    const renderAddedIcon = () => {
        if (!column.selected || column.alwaysEnabled) {
            return null;
        }
        return (React.createElement(Tooltip, { title: "This is already present in the selected columns", placement: "top-end" },
            React.createElement(Icon, { id: "added-icon", "data-testid": `${column.value}_added`, className: classes.iconSuccess }, "check_circle")));
    };
    const renderAdd = () => {
        if (props.selected || column.alwaysEnabled) {
            return null;
        }
        return (React.createElement("button", { onClick: handleSelect, className: "button-add" },
            React.createElement(Icon, { id: "add-icon", className: classes.icon }, "add_circle_outline")));
    };
    const renderRightActions = () => {
        return (React.createElement(React.Fragment, null,
            renderEdit(),
            !props.canRemove && renderAddedIcon(),
            props.canRemove && renderRemove(),
            renderAdd()));
    };
    const renderInfoTooltip = () => {
        if (typeof column.disabled !== 'string' || !column.disabled) {
            return null;
        }
        const message = column.disabled;
        return React.createElement(InfoIcon, { className: classes.infoIcon, message: message });
    };
    const listItemId = column.alwaysEnabled
        ? 'list-item-always-enabled'
        : 'list-item';
    let disabledItemClass;
    if (column.alwaysEnabled) {
        disabledItemClass = isAlwaysEnabledClassName;
    }
    else if (column.disabled && column.selected) {
        disabledItemClass = hasErrorClassName;
    }
    else if (column.disabled) {
        disabledItemClass = isDisabledClassName;
    }
    return (React.createElement(ListItem, { id: listItemId, key: column.value, className: cx(classes.item, disabledItemClass) },
        React.createElement("div", { className: classes.leftGroup },
            renderLeftActions(),
            React.createElement("div", { className: cx('list-item-label', classes.itemLabel), title: column.label }, column.label),
            renderInfoTooltip()),
        React.createElement("div", { className: classes.rightGroup }, renderRightActions())));
}
export default ColumnSelectorCardItem;
//# sourceMappingURL=ColumnSelectorCardItem.js.map